<table
  class="comp table-striped compSize borderless"
  width="100%"
  cellspacing="0"
  border="0"
>
  <thead>
    <tr>
      <th></th>
    </tr>
    <tr>
      <th>
        <div class="group-chips" *ngIf="showStudentGroups">
          <group-chips
            [hasStudentSelected]="hasStudentSelected"
            (addGroupClicked)="addGroupClicked.emit()"
            (addStudentsToGroupClicked)="addStudentsToGroupClicked.emit()"
            (removeStudentsFromGroupClicked)="
              removeStudentsFromGroupClicked.emit()
            "
          ></group-chips>
        </div>
      </th>
    </tr>
    <tr class="overall-row">
      <th class="overall-title-col">
        <div class="checkbox-and-title">
          <mat-checkbox
            [checked]="selectedAll"
            (change)="selectAllChange.emit($event)"
            class="select-all-checkbox"
          ></mat-checkbox>
          <div>
            <span class="overall-title">{{ school?.name?.title }}</span>
            <span class="goal-title">{{ school?.name?.goalTitle }}</span>
          </div>
        </div>
      </th>
    </tr>
  </thead>
</table>
